// extracted by mini-css-extract-plugin
export default {"cardPollo":"cardPollo_cardPollo__2uA9i","container-img":"cardPollo_container-img__aVeKP"};